<template>
  <el-card v-loading="loading">
    <template slot="header">
      <el-steps :active="active" align-center>
        <el-step title="Checking in"> </el-step>
        <el-step title="Select Unit"> </el-step>
        <el-step title="Pricing"> </el-step>
        <el-step title="Deposit"> </el-step>
        <!-- <el-step title="Agreement"> </el-step> -->
        <el-step title="Confirm"> </el-step>
      </el-steps>
    </template>
    <el-card shadow="never" v-if="active === 0">
      <el-form :model="form" :rules="rules" ref="details" label-width="250px">
        <el-form-item
          v-if="unitType"
          label="Rent To"
          prop="selectedCustomer"
          :rules="[
            {
              required: true,
              message: 'Please select Customer',
              trigger: 'blur',
            },
          ]"
        >
          <el-select
            v-model="form.selectedCustomer"
            placeholder="Eligible Customers"
            filterable
            @change="customerSelected"
            @focus="getFacilityCustomers"
            :remote-method="searchCustomers"
            remote
            :loading="customerLoading"
          >
            <el-option
              :key="customer._id"
              v-for="customer in customers"
              :value="customer._id"
              :label="`${customer.company || ''} ${customer.email}`"
            >
              <el-tag v-if="customer.company">{{
                customer.company
              }}</el-tag>
              <div v-else>No name found</div>
              {{ customer.email }}
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="Select Move In Date"
          prop="moveIn"
          :rules="[
            {
              required: true,
              message: 'Please input move in',
              trigger: 'blur',
            },
          ]"
        >
          <el-date-picker
            v-model="form.moveIn"
            @change="() => getUnits()"
            type="date"
            :picker-options="datePickerOptions"
            placeholder="Pick a MoveIn Date"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="Select Move Out Date" prop="moveOut">
          <el-date-picker
            v-model="form.moveOut"
            type="date"
            :picker-options="moveOutDatePickerOptions"
            placeholder="Pick a Move Out Date"
            :disabled="!this.form.moveIn"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="Billing Cycle">
          <!-- <el-col :span="11"> -->
          <el-select size="small" disabled v-model="form.billingType">
            <el-option label="Monthly" value="Monthly"> </el-option>
          </el-select>
        </el-form-item>
        <el-button :style="{ marginTop: '12px' }" @click="next">Next step</el-button>
      </el-form>
    </el-card>
    <el-card shadow="never" v-else-if="active === 1">
      <el-select
        v-model="selectedUnits"
        size="large"
        multiple
        style="margin-left: 20px; width: 250px"
        placeholder="Select Unit"
      >
        <el-option
          v-for="item in units"
          :key="item._id"
          :label="`${item.name} SIZE(${item.computedSize}) TIER(${
            item.tierQuality
          })`"
          :value="item._id"
        >
        </el-option>
      </el-select>
      <el-table v-show="conflicts.length" :data="conflicts">
        <el-table-column prop="unit.name" label="Unit"></el-table-column>
        <el-table-column
          prop="moveIn"
          label="Conflict Move In"
          :formatter="(row, column, cellValue) => $options.filters.formatDate(cellValue, this.$root.state.facilityData)"
        ></el-table-column>
        <el-table-column prop="customer.company" label="Customer"></el-table-column>
      </el-table>
      <el-button
        style="margin-top: 12px"
        type="warning"
        plain
        @click="() => (active -= 1)"
      >
        Back
      </el-button>
      <el-button
        :disabled="selectedUnits.length === 0"
        style="margin-top: 12px"
        @click="prepareSelectedUnit"
      >
        Next step
      </el-button>
    </el-card>
    <el-card shadow="never" v-loading="preparingSelectedUnitsData" v-else-if="active === 2" class="box-card" :body-style="{ width: '100%'}">
      <div slot="header" class="clearfix">
        <span>Total Monthly Price:</span>
        <!-- <span v-else>
          Approximated Price from {{ new Date( this.form.moveIn).toLocaleDateString() }} - {{ new Date( this.form.moveOut).toLocaleDateString() }}:
        </span> -->
        <span style="float: right">
          <el-tag disable-transitions>
            {{ Math.round(totalPrice() * 100 ) / 100 | currencySign($root.state.facilityData)}}
          </el-tag>
        </span>
      </div>
      <el-table v-if="selectedUnitsData.length" :data="selectedUnitsData">
        <el-table-column label="Unit Name" width="120">
          <template slot-scope="scope">
            {{ scope.row.name }}
          </template>
        </el-table-column>
        <el-table-column label="Unit Size" width="120">
          <template slot-scope="scope">
            {{ scope.row.computedSize }} Sq ft.
          </template>
        </el-table-column>
        <el-table-column prop="tierQuality" label="Tier Quality" :width="100">
          <template slot-scope="scope">
            {{ scope.row.tierQuality === 'AA' ? 'A+' : scope.row.tierQuality }}
          </template>
        </el-table-column>
        <el-table-column label="Pricing" :width="200">
          <template slot-scope="scope">
            <el-row>
              <el-col :span="14">
                <el-input-number
                  v-if="scope.row.editable"
                  size="mini"
                  :min="1"
                  v-model.number="scope.row.editPrice"
                  :controls="false"
                >
                </el-input-number>
                <div v-else>
                  {{ computePrice(scope.row, false, true) | currencySign($root.state.facilityData) }}
                </div>
              </el-col>
              <el-col :span="6">
                <el-checkbox :disabled="!allowAccess('level_3')" v-model="scope.row.editable" ></el-checkbox>
              </el-col>
            </el-row>
          </template>
        </el-table-column>
        <!-- <el-table-column label="Edit Price" :width="50">
          <template slot-scope="scope">
            <el-checkbox :disabled="!allowAccess('level_2')" v-model="scope.row.editable" ></el-checkbox>
          </template>
        </el-table-column> -->
        <el-table-column label="Security Deposit" :width="200">
          <template slot-scope="scope">
            <el-row>
              <el-col :span="14">
                <el-input-number
                  v-if="scope.row.depositEditable"
                  size="mini"
                  :min="1"
                  v-model.number="scope.row.editDeposit"
                  :controls="false"
                >
                </el-input-number>
                <div v-else>
                  {{  computePrice(scope.row, false, true) | currencySign($root.state.facilityData) }}
                </div>
              </el-col>
              <el-col :span="6">
                <el-checkbox :disabled="!allowAccess('level_3')" v-model="scope.row.depositEditable" ></el-checkbox>
              </el-col>
            </el-row>
          </template>
        </el-table-column>
        <el-table-column :label="facilitySecurityFeeLabel">
          <template slot-scope="scope">
            <div>
              {{ computeSecurityFee(scope.row.computedSize) | currencySign($root.state.facilityData) }}
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-button
        style="margin-top: 12px"
        type="warning"
        plain
        @click="() => (active -= 1)"
      >
        Back
      </el-button>
      <el-button style="margin-top: 12px" @click="next">
        Next step
      </el-button>
    </el-card>
    <div v-else-if="active === 3">
      <el-card shadow="never">
        <div slot="header" class="clearfix">
          <span>Charges due today:</span>
          <span style="float: right">
            <el-tag disable-transitions>
              {{
                (Math.round(totalDeposit() * 100) / 100) +
                (Math.round(totalSecurityFee() * 100) / 100) +
                (Math.round(computedProratedPrice() * 100) / 100) +
                (Math.round(totalTax() * 100) / 100) +
                (Math.round(totalSecurityFeeTax() * 100) / 100) | currencySign($root.state.facilityData)

              }}
            </el-tag>
          </span>
        </div>
        <div>
          <el-table :data="proratedTable()" fit>
            <el-table-column prop="name" label="Item"> </el-table-column>
            <el-table-column label="Price" prop="value"> </el-table-column>
          </el-table>
        </div>
        <el-button
          style="margin-top: 12px"
          type="warning"
          plain
          @click="() => (active -= 1)"
          >Back</el-button
        >
        <el-button style="margin-top: 12px" @click="next">Next step</el-button>
      </el-card>
    </div>
    <div v-else-if="active === 4">
      <el-card shadow="never">
        <div slot="header" class="clearfix">
          <span>
            {{ nextBillingDate }}
          </span>
        </div>

        <el-alert
          v-if="!(customerPGData && customerPGData.paymentMethods.length) && !walletHasMoney"
          title="Customer Payment Method not found"
          type="warning"
          :closable="false"
        >
        </el-alert>

        <h1>Amount Due: {{ dueAmount | currencySign($root.state.facilityData) }}</h1>
        <div style="margin-top: 12px">
          <el-button
            v-if="defaultPayment || walletHasMoney"
            type="primary"
            :loading="booking"
            @click="() => makeBookingV2(defaultPayment && amountToBePaidByDefaultPayment > 0, walletHasMoney)"
          >
            Pay Now
          </el-button>
          <el-button
            :loading="booking"
            plain
            @click="() => {
              markAsBalance = true;
              makeBookingV2(false, false)
            }"
          >
            Add Balance to Customer and complete the booking.
          </el-button>

          <section v-if="defaultPayment && amountToBePaidByDefaultPayment > 0">
            <el-divider></el-divider>
            <el-alert
              title="Payment Gateway Alert"
              type="info"
              :center="true"
              :closable="false"
            >
              Payments made now will be processed using {{ defaultPayment.bankName || defaultPayment.cardType }}, amount: {{ amountToBePaidByDefaultPayment | currencySign($root.state.facilityData) }}
            </el-alert>
          </section>

          <section v-if="walletHasMoney">
            <el-divider></el-divider>
            <el-alert
              title="Customer Wallet Alert"
              type="info"
              :center="true"
              :closable="false"
            >
              Pay using wallet amount: {{amountToBePaidByWallet | currencySign($root.state.facilityData) }}
            </el-alert>
          </section>

          <!-- <section v-if="insufficientBalance && walletHasMoney">
            <el-divider></el-divider>
            <el-alert
              title="Amount Due Alert"
              type="info"
              :center="true"
              :closable="false"
            >
              Balance Due Amount: {{ dueAmount - this.facilityAccount.wallet | currencySign($root.state.facilityData) }}
            </el-alert>
          </section> -->
        </div>

        <!-- <el-button :loading="booking" v-else-if="selectedDepositOption === 'next month' || selectedDepositOption === 'paid'" @click="() => makeBooking(false)">
          Book now
        </el-button> -->
      </el-card>
      <el-button
        v-if="!booking"
        style="margin-top: 12px"
        type="warning"
        plain
        @click="() => (active -= 1)"
        >Back</el-button
      >
      <!-- <el-button style="margin-top: 12px;" @click="next">Next step</el-button> -->
    </div>
  </el-card>
</template>

<script>
import axios from 'axios';
import {
  CUSTOMER_API_BASE,
  PG_API_BASE,
  UNITS_API_BASE_V2,
  ADMIN_API_BASE,
  UNIT_RENTAL_API_V1_1,
  FACILITY_ACCOUNT_API_BASE,
  FACILITY_TRANSACTIONS_API_BASE,
  LEASING_API,
  WORKFLOW_API_BASE,
} from '../env';
import { allowAccess } from '../utils/roles';
import { updateCustomer } from '../api/customers';
import { getTotalMonths, setMoveinToUTC, setMoveoutToUTC } from '../utils/timing';
import { computeUnitPricing, round, getLeaseTaxLineItem } from '../utils/pricing';
import { stillfullApplicableStatuses } from '../utils/status';
import { nanoid } from 'nanoid';

export default {
  name: 'CustomerRental',
  props: {
    facility: { type: String, required: true },
    customerId: { type: String, default: null },
    unit: { type: String, default: null },
    waitList: { type: Object, default: null },
    unitType: { type: Boolean, default: false },
  },
  watch: {
    async customerId() {
      await this.getCustomerFromBraintree();
      await this.getCustomerFacilityAccount();
    },
    async facility() {
      this.clearFields();
      this.loading = true;
      if (this.waitList) {
        this.form.moveIn = new Date(this.waitList.desiredDate);
        this.form.minSize = this.waitList.minSize;
        this.form.maxSize = this.waitList.maxSize;
      }
      await this.getFacility();
      await this.getUnits();
      await this.getCustomerFromBraintree();
      this.loading = false;
    },
  },
  async mounted() {
    this.loading = true;
    if (this.waitList) {
      this.form.moveIn = new Date(this.waitList.desiredDate);
      this.form.minSize = this.waitList.minSize;
      this.form.maxSize = this.waitList.maxSize;
    }

    await this.getFacility();
    if (!this.customerId) {
      await this.getFacilityCustomers();
    } else {
      this.selectedCustomer = this.customerId;
      await this.getCustomer();
    }

    await this.getUnits();
    if (this.unit) {
      this.selectedUnits = [this.unit];
    }

    await this.getCustomerFromBraintree();
    await this.getCustomerFacilityAccount();
    this.loading = false;
  },
  computed: {
    facilitySecurityFeeLabel() {
      let label = 'Security';

      const facility = this.facilityData;
      if (facility && facility.securityFee && facility.securityFee.label) {
        label = facility.securityFee.label;
      }

      return label;
    },
    isBanned() {
      if (this.customerId) {
        if (this.customerData && this.customerData.ban) {
          return true;
        }
      }
      return false;
    },
    amountToBePaidByWallet() {
      if (!this.walletHasMoney) {
        return 0;
      }
      if (this.walletHasMoney && this.dueAmount > this.facilityAccount.wallet) {
        return round(this.facilityAccount.wallet);
      } else if (this.walletHasMoney && this.dueAmount < this.facilityAccount.wallet) {
        return this.facilityAccount.wallet - (this.facilityAccount.wallet - this.dueAmount);
      }
      return this.dueAmount;
    },
    amountToBePaidByDefaultPayment() {
      if (this.walletHasMoney) {
        return this.dueAmount - this.amountToBePaidByWallet;
      }
      return this.dueAmount;
    },
    defaultPayment() {
      if (this.customerPGData) {
        const [defaultPaymentMethod] = this.customerPGData.paymentMethods
          .filter(item => item.default === true);
        return defaultPaymentMethod;
      }
      return null;
    },
    creditCardFee() {
      if (this.creditCardSelected) {
        return round(
          this.amountToBePaidByDefaultPayment * (this.facilityData.creditCardFee.fee / 100),
        );
      }
      return 0;
    },
    creditCardSelected() {
      const cardTokens = this.customerPGData.creditCards.map(card => card.token);
      return cardTokens.includes(this.defaultPayment.token);
    },
    dueAmount() {
      return (
        round(this.totalDeposit()) +
        round(this.totalSecurityFee()) +
        round(this.computedProratedPrice()) +
        round(this.totalTax()) +
        round(this.totalSecurityFeeTax())
      );
    },
    dueAmountToBePaidbyWallet() {
      if (this.dueAmount > this.facilityAccount.wallet) {
        return round(this.facilityAccount.wallet);
      }
      return this.dueAmount;
    },
    walletHasMoney() {
      if (this.facilityAccount.wallet) {
        return this.facilityAccount.wallet > 0;
      }
      return false;
    },
    insufficientBalance() {
      return this.dueAmount > this.facilityAccount.wallet;
    },
    nextBillingDate() {
      const value = this.getNextBillingDate();
      if (value) { return `Next billing date: ${this.$options.filters.formatDate(value)}`; }

      return 'Confirm';
    },
    securityFeeEnabled() {
      return this.facilityData && this.facilityData.securityFee && this.facilityData.securityFee.enabled && this.facilityData.securityFee.fee > 0;
    },
    securityFeeTaxEnabled() {
      if (this.feeTaxEnabled) {
        return false;
      }
      if (this.facilityData.feeTypesTaxPricing && this.facilityData.feeTypesTaxPricing.length) {
        const securityFeeTax = this.facilityData.feeTypesTaxPricing.find(feeTypeTax => feeTypeTax.type === 'Security');
        if (securityFeeTax) {
          return true;
        }
      }
      return false;
    },
    feeTaxEnabled() {
      return this.facilityData.feeTaxFlag && this.facilityData.feeTypesTaxPricing && this.facilityData.feeTypesTaxPricing.length;
    },
  },
  data() {
    const moveOutValidate = (rule, value, callback) => {
      if (!value) {
        callback();
      }
      if (value < this.form.moveIn) {
        callback(new Error('Move out date can not be less than move in.'));
      } else {
        callback();
      }
    };

    const disabledDate = (date) => {
      if (this.form.moveIn) {
        const moveIn = new Date(this.form.moveIn.getTime());
        moveIn.setDate(moveIn.getDate() + 1);
        return date < moveIn;
      }
      const today = new Date();
      return date < today;
    };

    return {
      preparingSelectedUnitsData: false,
      loading: false,
      booking: false,
      markAsBalance: false,
      conflicts: [],
      customerLoading: false,
      facilityAccountExists: false,
      settlementPending: false,
      facilityAccount: {},
      dialogFormVisible: false,
      agreementIsDraft: true,
      org: null,
      customers: [],
      originalCustomers: [],
      facilityData: null,
      customerData: null,
      customerPGData: null,
      customerCompData: null,
      form: {
        selectedCustomer: null,
        moveIn: '',
        moveOut: '',
        billingType: 'Monthly',
        pricing: {
          price: null,
          reservationPrice: null,
          setupFee: null,
          deposit: null,
          currency: null,
        },
        size: '',
        minSize: '',
        maxSize: '',
        tierQuality: '',
      },
      unitPrices: [],
      unitDeposits: [],
      amount: 0,
      deposit: 0,
      tags: [],
      units: [],
      selectedUnits: [],
      selectedUnitsData: [],
      tagInput: '',
      active: 0,
      datePickerOptions: {
        disabledDate(date) {
          const today = new Date();
          const yesterday = new Date(today.getTime());
          yesterday.setDate(today.getDate() - 1);
          return date < yesterday;
        },
      },
      moveOutDatePickerOptions: {
        disabledDate,
      },
      rules: {
        moveOut: {
          validator: moveOutValidate,
          trigger: 'blur',
        },
      },
      images: [],
    };
  },
  methods: {
    allowAccess(role) {
      return allowAccess(role, this.$keycloak, this.$root.state.facility);
    },
    async getCustomer(customerId) {
      const id = this.customerId || customerId;
      if (!id) {
        return;
      }
      const customer = await axios.get(
        `${CUSTOMER_API_BASE}/customers/v1/${id}`,
        {
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
        },
      );
      this.customerData = customer.data;
    },
    async customerSelected(customer) {
      this.$emit('customer-selected', customer);
      await this.getCustomer(customer);
      if (this.isBanned) {
        this.clearFields();
        this.$emit('close');
        this.$message.warning({
          title: 'Warning',
          message: 'Customer is banned',
        });
      }
    },
    async searchCustomers(searchText) {
      try {
        if (!searchText) {
          await this.getFacilityCustomers();
          return;
        }
        this.customerLoading = true;
        const customers = await axios.get(`${CUSTOMER_API_BASE}/customers/v1/get/all`, {
          params: { fullname: searchText },
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
        });
        this.customerLoading = false;
        // eslint-disable-next-line no-console
        this.customers = customers.data;
      } catch (err) {
        this.customerLoading = false;
      }
    },
    async getFacilityCustomers() {
      try {
        this.customerLoading = true;
        const response = await axios.get(`${CUSTOMER_API_BASE}/customers/v2/facility/${this.facility}`, {
          params: {
            type: 'both',
          },
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
        });
        this.customers = response.data;
        this.customerLoading = false;
      } catch (err) {
        this.customerLoading = false;
      }
    },
    async getEligibleCustomers() {
      try {
        this.customerLoading = true;
        const response = await axios.get(
          `${CUSTOMER_API_BASE}/customers/v1/get/eligible/customers/${this.facility}`,
          {
            headers: {
              Authorization: `Bearer ${this.$keycloak.token}`,
            },
          },
        );
        this.customers = response.data;
        this.originalCustomers = response.data;
        this.customerLoading = false;
      } catch (err) {
        this.customerLoading = false;
        console.log(err);
      }
    },
    async getCustomerFacilityAccount() {
      try {
        if (this.customerId) {
          const response = await axios.get(
            `${FACILITY_ACCOUNT_API_BASE}/v1/${this.facility}/${this.customerId}`,
            {
              headers: {
                Authorization: `Bearer ${this.$keycloak.token}`,
              },
            },
          );
          this.facilityAccountExists = true;
          this.facilityAccount = response.data;
          this.facilityAccount.wallet =
            this.facilityAccount.amountPaid && this.facilityAccount.amount >= 0
              ? this.facilityAccount.amountPaid - this.facilityAccount.amount
              : 0;
        }
      } catch (err) {
        this.facilityAccountExists = false;
        this.facilityAccount = {
          wallet: 0,
          amount: 0,
          amountPaid: 0,
          deposit: 0,
          depositToBeRefunded: 0,
        };
        this.$message({
          showClose: true,
          offset: 90,
          type: 'info',
          duration: 10000,
          message:
            'Customer Facility Account not found! Complete Rent Customer flow to create it.',
        });
      }
    },
    proratedTable() {
      return [
        {
          name: this.facilitySecurityFeeLabel,
          value: this.securityFeeEnabled
            ? `${this.$options.filters.currencySign(this.totalSecurityFee(), this.$root.state.facilityData)} for ${
              this.proratedDays
            } Day(s)`
            : `${this.facilitySecurityFeeLabel} Disabled`,
        },
        {
          name: 'Security Deposit',
          value: `${this.$options.filters.currencySign(this.totalDeposit(), this.$root.state.facilityData)}`,
        },
        {
          name: 'Prorated Rent',
          value: `${this.$options.filters.currencySign(Number(this.computedProratedPrice()), this.$root.state.facilityData)} for ${
            this.proratedDays
          } Day(s)`,
        },
        {
          name: 'Tax',
          value: this.facilityData.rentTaxFlag
            ? `${this.$options.filters.currencySign(this.totalTax(), this.$root.state.facilityData)}`
            : 'Tax Disabled',
        },
        {
          name: `${this.facilitySecurityFeeLabel} Tax`,
          value: this.securityFeeTaxEnabled
            ? `${this.$options.filters.currencySign(this.totalSecurityFeeTax(), this.$root.state.facilityData)}`
            : `${this.facilitySecurityFeeLabel} Tax Disabled`,
        },
      ];
    },
    async createFacilityWalletTransaction(invoice) {
      const walletFacilityTransaction = {
        facility: this.facility,
        customer: this.customerId,
        facilityAccount: this.facilityAccount._id,
        invoice: invoice._id,
        details: 'Transaction using wallet while booking',
        amount: this.amountToBePaidByWallet,
        amountPaid: this.amountToBePaidByWallet,
        createdBy: this.$keycloak.tokenParsed.email,
        createdAt: new Date(),
        success: true,
        type: 'WALLET',
      };

      const { data } = await axios.post(`${FACILITY_TRANSACTIONS_API_BASE}/v1/${this.facility}/transaction/initiate/cww`, {
        ...walletFacilityTransaction,
      }, {
        headers: {
          Authorization: `Bearer ${this.$keycloak.token}`,
        },
      });

      return data.result.transaction;
    },
    async createInitialFacilityPGTransaction(invoice) {
      const pgfacilityAccountTransaction = {
        facility: this.facility,
        customer: this.customerId,
        facilityAccount: this.facilityAccount._id,
        invoice: invoice._id,
        details: 'Transaction using PaymentGateway while booking',
        amount: this.amountToBePaidByDefaultPayment,
        createdBy: this.$keycloak.tokenParsed.email,
        createdAt: new Date(),
        success: false,
        type: this.defaultPayment && this.defaultPayment.bankName ? 'ACH' : 'CREDIT_CARD',
        ...(this.defaultPayment && this.defaultPayment.cardType && this.facilityData.creditCardFee && this.facilityData.creditCardFee.enabled ?
          { enabledCreditCardFee: this.facilityData.creditCardFee.enabled } : {}),
        ...(
          this.defaultPayment && this.defaultPayment.cardType &&
          this.facilityData.creditCardFee &&
          this.facilityData.creditCardFee.enabled &&
          this.facilityData.creditCardFee.fee ?
            {
              creditCardFee: round(
                this.amountToBePaidByDefaultPayment * (this.facilityData.creditCardFee.fee / 100),
              ),
            } : {}),
      };

      const { data } = await axios.post(`${FACILITY_TRANSACTIONS_API_BASE}/v1/${this.facility}/transaction/initiate/pg`, {
        ...pgfacilityAccountTransaction,
      }, {
        headers: {
          Authorization: `Bearer ${this.$keycloak.token}`,
        },
      });

      return data.result.transaction;
    },
    async getConflicts() {
      this.loading = true;
      const response = await axios.get(`${LEASING_API}/v1/${this.facility}/conflicts`, {
        params: {
          units: this.selectedUnits.toString(),
          moveIn: this.form.moveIn,
        },
        headers: {
          Authorization: `Bearer ${this.$keycloak.token}`,
        },
      });

      this.conflicts = response.data;

      if (this.conflicts.length) {
        this.$alert(`
        <strong>There is a future lease for one or multiple units for this lease that overlaps with the proposed move in date of this lease.
          You must cancel the conflicting future lease(s) prior to creating this new lease.</strong>
        `, 'Conflict found!', {
          confirmButtonText: 'OK',
          dangerouslyUseHTMLString: true,
          // callback: (action) => {
          // this.$message({
          //   type: 'info',
          //   message: `action: ${action}`,
          // });
          // },
        });
      }

      this.loading = false;
      return response.data;
    },
    // async updateFacilityAccountTransactionWithBraintree(braintreeTransaciton, facilityPGTransaction) {
    //   const response = await axios.put(`${FACILITY_TRANSACTIONS_API_BASE}/v1/${facilityPGTransaction.id}`, {
    //     pgTransaction: braintreeTransaciton,
    //     transactionUpdated: facilityPGTransaction,
    //   }, {
    //     headers: {
    //       Authorization: `Bearer ${this.$keycloak.token}`,
    //     },
    //   });

    //   return response.data;
    // },
    async makeBookingV2(chargeViaPG, chargeViaWallet) {
      const dueDate = setMoveinToUTC(this.form.moveIn);
      const finalLineItems = this.prepareLineItems(dueDate);
      const securityFeeLineItemAppliedAt = this.securityFeeEnabled;

      const lease = {
        createdBy: this.$keycloak.tokenParsed.email,
        customerId: this.customerId,
        start: setMoveinToUTC(this.form.moveIn),
        end: this.form.moveOut ? setMoveoutToUTC(this.form.moveOut) : null,
        facility: this.facility,
        status: 'PENDING',
        units: this.selectedUnits,
        ...(securityFeeLineItemAppliedAt ? { securityFeeAppliedAt: setMoveinToUTC(this.form.moveIn) } : {}),
        lineItems: [...finalLineItems],
        amount: this.dueAmount,
        amountPaid: 0,
        // agreement: this.managerSignatureUrl,
        events: [{ type: 'booking_initiated', units: this.selectedUnits }],
        pricing: {
          price: this.amount,
          dTier: this.facilityData.pricing.dTier,
          qualityPricing: this.facilityData.pricing.qualityPricing,
          currency: this.facilityData.pricing.currency,
        },
        parkingPricing: {
          ...this.facilityData.parkingPricing,
        },
        officePricing: {
          ...this.facilityData.officePricing,
        },
        deposit: this.deposit,
        depositPaid: 0,
      };

      const unitRentals = this.selectedUnitsData.map(unit => ({
        createdBy: this.$keycloak.tokenParsed.email,
        moveIn: setMoveinToUTC(this.form.moveIn),
        moveOut: this.form.moveOut ? setMoveoutToUTC(this.form.moveOut) : null,
        status: 'PENDING',
        billingType: this.form.billingType,
        facility: this.facility,
        ...(securityFeeLineItemAppliedAt ? { securityFeeAppliedAt: setMoveinToUTC(this.form.moveIn) } : {}),
        customer: this.customerId,
        ...(unit.editable ? {
          updatedPrice: unit.editPrice,
          updatedPriceAt: new Date(),
          updatedBy: this.$keycloak.tokenParsed.email,
        } : {}),
        unit: unit._id,
        ...(stillfullApplicableStatuses.includes(unit.status) ? {
          stillFullApplied: this.facilityData.stillFullFlag,
          stillFullPrice: this.facilityData.stillFullPrice,
        } : {}),
        lineItems: finalLineItems.filter(item => item.unit === unit._id),
        pricing: {
          price: this.computePrice(unit, false, true),
          dTier: this.facilityData.pricing.dTier,
          qualityPricing: this.facilityData.pricing.qualityPricing,
          currency: this.facilityData.pricing.currency,
        },
        parkingPricing: {
          ...this.facilityData.parkingPricing,
        },
        officePricing: {
          ...this.facilityData.officePricing,
        },
        securityDeposit: unit.depositEditable ? unit.editDeposit : this.computePrice(unit, false, true),
        appliedCustomDeposit: unit.depositEditable,
      }));

      const workflowBody = {
        facility: this.facility,
        customer: this.customerId,
        customerInvoice: lease,
        unitRentals,
        chargeViaWallet,
        chargeViaPG,
        amountToBePaidByWallet: this.markAsBalance ? 0 : this.amountToBePaidByWallet,
        amountToBePaidByDefaultPayment: this.markAsBalance ? 0 : this.amountToBePaidByDefaultPayment,
        transaction: {
          facility: this.facility,
          customer: this.customerId,
          facilityAccount: this.facilityAccount._id,
          details: 'Transaction using PaymentGateway while booking',
          amount: this.amountToBePaidByDefaultPayment,
          createdBy: this.$keycloak.tokenParsed.email,
          createdAt: new Date(),
          success: false,
          type: this.defaultPayment && this.defaultPayment.bankName ? 'ACH' : 'CREDIT_CARD',
          ...(this.defaultPayment && this.defaultPayment.cardType && this.facilityData.creditCardFee && this.facilityData.creditCardFee.enabled ?
            { enabledCreditCardFee: this.facilityData.creditCardFee.enabled } : {}),
          ...(
            this.defaultPayment && this.defaultPayment.cardType &&
          this.facilityData.creditCardFee &&
          this.facilityData.creditCardFee.enabled &&
          this.facilityData.creditCardFee.fee ?
              {
                creditCardFee: this.creditCardFee,
              } : {}),
        },
      };

      this.booking = true;
      await axios.post(`${WORKFLOW_API_BASE}/v1/lease`, {
        ...workflowBody,
      }, {
        headers: {
          Authorization: `Bearer ${this.$keycloak.token}`,
        },
      });
      if (this.customerId && this.facility) {
        const customerResponse = await axios.get(
          `${CUSTOMER_API_BASE}/customers/v1/${this.customerId}`,
          {
            headers: {
              Authorization: `Bearer ${this.$keycloak.token}`,
            },
          },
        );
        const currentLocations = Array.isArray(customerResponse.data.locations)
          ? customerResponse.data.locations.map(location => String(location))
          : [];
        const facilityId = String(this.facility);
        if (!currentLocations.includes(facilityId)) {
          const locations = Array.from(new Set([...currentLocations, facilityId]));
          await updateCustomer(this.customerId, { locations }, this.$keycloak.token);
          if (this.customerData) {
            this.customerData.locations = locations;
          }
        }
      }

      setTimeout(this.getCustomerInvoiceAndCloseDialog, 5000);
    },
    async getCustomerInvoiceAndCloseDialog() {
      const response = await axios.get(
        `${CUSTOMER_API_BASE}/customers/v1/customer/invoices/${this.customerId}`,
        {
          params: {
            facility: this.facility,
          },
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
        },
      );

      if (response.data) {
        this.booking = false;
        this.$emit('close');
        this.clearFields();
      } else {
        setTimeout(this.getCustomerInvoice(), 2000);
      }
    },
    async makeBooking(chargeViaPG, chargeViaWallet) {
      let invoiceResponse;
      try {
        this.booking = true;
        let transaction = '';
        if (!this.customerData) {
          const customer = await axios.get(
            `${CUSTOMER_API_BASE}/customers/v1/${this.customerId}`,
            {
              headers: {
                Authorization: `Bearer ${this.$keycloak.token}`,
              },
            },
          );
          this.customerCompData = customer.data;
        }

        if (!this.facilityAccountExists) {
          await this.createFacilityAccountIfNotExists();
        }

        try {
          invoiceResponse = await this.createInitialInvoice();
        } catch (err) {
          this.$message.error({
            title: 'Create Initial Invoice Failed!',
            message: err.response.data,
          });
          return;
        }

        let pgInitialTransaction = null;

        let walletTransaction = null;
        if (chargeViaWallet && this.amountToBePaidByWallet > 0) {
          walletTransaction = await this.createFacilityWalletTransaction(invoiceResponse.data);
        }

        if (chargeViaPG && this.amountToBePaidByDefaultPayment > 0) {
          pgInitialTransaction = await this.createInitialFacilityPGTransaction(invoiceResponse.data);
          const response = await this.chargeViaBraintree(pgInitialTransaction, invoiceResponse.data._id);
          pgInitialTransaction = await this.updateFacilityAccountTransactionWithBraintree(response.data.result, pgInitialTransaction);
          if (response.data.result.success) {
            transaction = response.data.result.transaction.id;
            const facilityAccountTransaction = {
              transaction,
              details: 'Paid while booking units.',
              amountPaid: this.amountToBePaidByDefaultPayment,
              amountDue: 0,
            };

            if (!this.facilityAccount.transactions) {
              this.facilityAccount.transactions = [facilityAccountTransaction];
            } else {
              this.facilityAccount.transactions.push(
                facilityAccountTransaction,
              );
            }
          }

          if (this.defaultPayment && this.defaultPayment.bankName) {
            if (response.data.result.transaction.status === 'settlement_pending') {
              this.settlementPending = true;
            }
          }
        }

        await this.addLeaseAmountPaidToCustomerFacilityAccount({ invoice: invoiceResponse.data, facilityTransactions: [...(walletTransaction ? [walletTransaction] : []), ...(pgInitialTransaction ? [pgInitialTransaction] : [])] });

        const dueDate = this.form.moveIn;
        const unitsInfo = this.selectedUnitsData.map(unit => ({
          unit: unit._id,
          name: unit.name,
        }));
        const finalDebitItems = this.prepareDebitLineItems([
          ...(walletTransaction ? [walletTransaction] : []),
          ...(pgInitialTransaction ? [pgInitialTransaction] : []),
        ], dueDate);

        const completedTransactions = [
          ...(walletTransaction ? [walletTransaction] : []),
          ...(pgInitialTransaction ? [pgInitialTransaction] : []),
        ];
        const successfullTransactions = completedTransactions
          .filter(completedTransaction => completedTransaction.success);
        const totalAmountPaid = successfullTransactions
          .map(successfullTransaction => successfullTransaction.amountPaid)
          .reduce((amountP, amountN) => amountP + amountN, 0);

        const lineItems = invoiceResponse.data.lineItems;

        const depositPaid = totalAmountPaid >= this.deposit ? this.deposit : totalAmountPaid;
        await axios.put(
          `${LEASING_API}/v1/${this.facility}/${invoiceResponse.data._id}`,
          {
            lineItems: [...lineItems, ...finalDebitItems],
            unitsInfo,
            amountPaid: totalAmountPaid,
            depositPaid,
            ...(depositPaid && depositPaid > 0 ? { depositPaidAt: new Date() } : {}),
            transactions: transaction ? [{ transaction }] : [],
            lastBilledDate: dueDate,
            lastDueDate: dueDate,
            ...(this.getNextBillingDate()
              ? { nextBillingDate: this.getNextBillingDate() }
              : {}),
          },
          {
            headers: {
              Authorization: `Bearer ${this.$keycloak.token}`,
            },
          },
        );

        const unitRentals = await this.createUnitRentalsBasedOnTheLease({
          transaction,
          invoiceResponse,
          lineItems,
        });
        const unitRentalIds = unitRentals.map(rental => rental._id);

        const unitRentalsInfo = unitRentals.map(rental => ({
          rental: rental._id,
          createdAt: rental.createdDate,
          moveIn: rental.moveIn,
          moveOut: rental.moveOut,
          name: [
            ...this.selectedUnitsData.filter(
              unit => unit._id === rental.unit,
            ),
          ][0].name,
        }));

        await axios.put(
          `${LEASING_API}/v1/${this.facility}/${invoiceResponse.data._id}`,
          {
            unitRentals: unitRentalIds,
            unitRentalsInfo,
          },
          {
            headers: {
              Authorization: `Bearer ${this.$keycloak.token}`,
            },
          },
        );
        if (this.settlementPending) {
          this.$message.warning({
            title: 'Settlement Pending',
            message: 'When amount is settled unit rent will be completed',
          });
        } else {
          this.$message.success({
            title: 'Booking Success.',
            message: 'Unit Rent completed',
          });
        }
        this.booking = false;
        this.$emit('close');
        this.clearFields();
      } catch (err) {
        console.log(err);
        if (invoiceResponse._id) {
          await axios.put(`${LEASING_API}/v1/${this.facility}/${invoiceResponse._id}/cancel`,
            {},
            {
              headers: {
                Authorization: `Bearer ${this.$keycloak.token}`,
              },
            },
          );
        }
        this.booking = false;
        this.$emit('error');
        this.$message.error({
          title: 'Booking failed.',
          message: err.message ? err.message : err.response.data,
        });
      }
    },
    async updateFacilityAccountTransactionWithBraintree(braintreeTransaction, facilityTransaction) {
      const response = await axios.put(`${FACILITY_TRANSACTIONS_API_BASE}/v1/${facilityTransaction.id}`, {
        pgTransaction: braintreeTransaction,
        transactionUpdate: facilityTransaction,
      }, {
        headers: {
          Authorization: `Bearer ${this.$keycloak.token}`,
        },
      });

      return response.data;
    },
    async addLeaseAmountPaidToCustomerFacilityAccount({ facilityTransactions }) {
      const amountPaid = facilityTransactions.map(transaction => transaction.amountPaid)
        .reduce((amtP, amtC) => amtP + amtC, 0);

      const depositPaid = this.deposit < amountPaid ? amountPaid - this.deposit : amountPaid;
      await axios.put(
        `${FACILITY_ACCOUNT_API_BASE}/v1/${this.facility}/${this.customerId}`,
        {
          transactions: this.facilityAccount.transactions,
          amountPaid: Number(this.facilityAccount.amountPaid + amountPaid),
          amount: Number(this.facilityAccount.amount + this.dueAmount),
          deposit: Number(this.facilityAccount.deposit + this.totalDeposit()),
          depositPaid: Number(this.facilityAccount.depositPaid + depositPaid),
          ...(depositPaid && depositPaid > 0 ? { depositPaidAt: new Date() } : {}),
        },
        {
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
        },
      );
    },
    async createFacilityAccountIfNotExists() {
      const result = await axios.post(
        `${FACILITY_ACCOUNT_API_BASE}/v1/account`,
        {
          amount: 0,
          amountPaid: 0,
          facility: this.facility,
          customer: this.customerId,
        },
        {
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
        },
      );
      this.facilityAccountExists = true;
      this.facilityAccount = result.data;
    },
    async createInitialInvoice() {
      const dueDate = this.form.moveIn;
      const finalLineItems = this.prepareLineItems(dueDate);
      const invoiceResponse = await axios.post(
        `${LEASING_API}/v1/${this.facility}/lease/create`,
        {
          createdBy: this.$keycloak.tokenParsed.email,
          customerId: this.customerId,
          start: this.form.moveIn,
          end: this.form.moveOut,
          facility: this.facility,
          status: 'PENDING',
          units: this.selectedUnits,
          lineItems: [...finalLineItems],
          amount: this.dueAmount,
          amountPaid: 0,
          // agreement: this.managerSignatureUrl,
          transactions: transaction ? [{ transaction }] : [],
          events: [{ type: 'booking_initiated', units: this.selectedUnits }],
          pricing: {
            price: this.amount,
            dTier: this.facilityData.pricing.dTier,
            qualityPricing: this.facilityData.pricing.qualityPricing,
            currency: this.facilityData.pricing.currency,
          },
          parkingPricing: {
            ...this.facilityData.parkingPricing,
          },
          officePricing: {
            ...this.facilityData.officePricing,
          },
          deposit: this.deposit,
          depositPaid: 0,
        },
        {
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
        },
      );
      return invoiceResponse;
    },
    async chargeViaBraintree(pgInitialTransaction, invoiceId) {
      const response = await axios.post(
        `${PG_API_BASE}/customer/transaction/create`,
        {
          paymentMethodToken: this.defaultPayment.token,
          customerId: this.customerId,
          customFields: {
            transaction: pgInitialTransaction.id,
            invoice: invoiceId,
          },
          amount: this.defaultPayment && this.defaultPayment.cardType && this.creditCardSelected && this.facilityData.creditCardFee && this.facilityData.creditCardFee.enabled ?
            round(
              this.amountToBePaidByDefaultPayment
              + (this.amountToBePaidByDefaultPayment * (this.facilityData.creditCardFee.fee / 100)),
            )
            : this.amountToBePaidByDefaultPayment,
          // lineItems: this.selectedUnits,
          options: {
            submitForSettlement: true,
          },
        },
        {
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
        },
      );
      return response;
    },
    async createUnitRentalsBasedOnTheLease({
      transaction,
      invoiceResponse,
      lineItems,
    }) {
      const response = await axios.post(
        `${UNIT_RENTAL_API_V1_1}/create/multiple`,
        {
          data: this.selectedUnitsData.map(unit => ({
            createdBy: this.$keycloak.tokenParsed.email,
            moveIn: this.form.moveIn,
            moveOut: this.form.moveOut,
            status: 'PENDING',
            billingType: this.form.billingType,
            facility: this.facility,
            customer: this.customerId,
            ...(unit.editable ? {
              updatedPrice: unit.editPrice,
              updatedPriceAt: new Date(),
              updatedBy: this.$keycloak.tokenParsed.email,
            } : {}),
            unit: unit._id,
            unitInvoice: invoiceResponse.data._id,
            ...(stillfullApplicableStatuses.includes(unit.status) ? {
              stillFullApplied: this.facilityData.stillFullFlag,
              stillFullPrice: this.facilityData.stillFullPrice,
            } : {}),
            lineItems: lineItems.filter(item => item.unit === unit._id),
            pricing: {
              price: this.computePrice(unit, false, true),
              dTier: this.facilityData.pricing.dTier,
              qualityPricing: this.facilityData.pricing.qualityPricing,
              currency: this.facilityData.pricing.currency,
            },
            parkingPricing: {
              ...this.facilityData.parkingPricing,
            },
            officePricing: {
              ...this.facilityData.officePricing,
            },
          })),
          status: 'PENDING',
          customer: this.customerId,
          invoice: invoiceResponse.data._id,
          facility: this.facility,
        },
        {
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
        },
      );
      return response.data;
    },
    clearFields() {
      this.form = {
        moveIn: '',
        moveOut: '',
        billingType: 'Monthly',
        pricing: {
          price: null,
          reservationPrice: null,
          setupFee: null,
          deposit: null,
          currency: null,
        },
        size: '',
        tierQuality: '',
      };

      this.unitPrices = [];
      this.unitDeposits = [];
      this.amount = 0;
      this.proratedAmount = 0;
      this.proratedDays = 0;
      this.deposit = 0;
      this.tags = [];
      this.units = [];
      this.selectedUnits = [];
      this.selectedUnitsData = [];
      this.tagInput = '';
      this.active = 0;
      this.rules = {};
      this.images = [];
    },
    computedProratedPrice() {
      let price = 0;
      this.selectedUnitsData.forEach((unit) => {
        const item = unit.editable ? this.newPrice(unit, true) : this.computePrice(unit, true);
        if (item > 0) {
          price += Number(item);
        }
      });
      this.proratedAmount = Number(price).toFixed(2);
      return Number(price).toFixed(2);
    },
    totalPrice() {
      let price = 0;
      this.selectedUnitsData.forEach((unit) => {
        const item = unit.editable ? this.newPrice(unit) : this.computePrice(unit);
        price += Number(item);
      });
      this.amount = Number(price).toFixed(2);
      return Number(price).toFixed(2);
    },
    totalTax() {
      if (this.customerData && this.customerData.taxExempted === true) {
        return 0;
      }
      let tax = 0;
      if (!this.facilityData.rentTaxFlag) {
        return 0;
      }
      this.selectedUnitsData.forEach((unit) => {
        const price = unit.editable ? this.newPrice(unit, true) : this.computePrice(unit, true);
        const taxValue = this.computeTax(price);
        tax += taxValue;
      });
      return round(tax);
    },
    totalSecurityFee() {
      let price = 0;
      this.selectedUnitsData.forEach((unit) => {
        if (this.securityFeeEnabled) {
          const securityFee = this.computeSecurityFee(unit.computedSize);
          const proratedSecurityFee = this.computeProratedSecurityFee(securityFee);
          price += Number(proratedSecurityFee);
        }
      });

      return round(price);
    },
    totalSecurityFeeTax() {
      if (this.customerData && this.customerData.taxExempted === true) {
        return 0;
      }
      let price = 0;
      this.selectedUnitsData.forEach((unit) => {
        if (this.securityFeeEnabled && this.securityFeeTaxEnabled) {
          const securityFee = this.computeSecurityFee(unit.computedSize);
          const proratedSecurityFee = this.computeProratedSecurityFee(securityFee);
          const securityFeeTypeTax = this.computeSecurityFeeTax(proratedSecurityFee);
          price += Number(securityFeeTypeTax);
        }
      });

      return round(price);
    },
    totalDeposit() {
      let price = 0;
      this.selectedUnitsData.forEach((unit) => {
        const item = unit.depositEditable ? unit.editDeposit
          : unit.editable
            ? this.newPrice(unit, false, true) : this.computePrice(unit, false, true);
        price += Number(item);
      });

      this.deposit = price;
      return round(price);
    },
    async getCustomerFromBraintree() {
      if (this.customerId) {
        const response = await axios.get(
          `${PG_API_BASE}/customer/${this.customerId}`,
          {
            headers: {
              Authorization: `Bearer ${this.$keycloak.token}`,
            },
          },
        );
        this.customerPGData = response.data.customer;
      }
    },
    async getUnits() {
      try {
        const units = await axios.get(`${UNITS_API_BASE_V2}/${this.facility}`, {
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
          params: {
            limit: 250,
            status: 'AVAILABLE',
            ...(this.form.moveIn ? { moveIn: this.form.moveIn } : {}),
            // ...(this.form.size ? { size: this.form.size } : {}),
            // ...(this.form.maxSize ? { maxSize: this.form.maxSize } : {}),
            // ...(this.form.minSize ? { minSize: this.form.minSize } : {}),
          },
        });
        this.units = [...units.data.result, ...units.data.availableUnits];
        this.units = this.units.sort((a, b) =>
          a.name.localeCompare(b.name, 'en', { numeric: true }),
        );
      } catch (err) {
        this.loading = false;
        this.$notify.error({
          title: 'Error',
          message: err.response.data,
        });
      }
    },
    async getFacility() {
      const facility = await axios.get(
        `${ADMIN_API_BASE}/facilities/${this.facility}`,
        {
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
        },
      );
      this.facilityData = facility.data;
    },
    computeSecurityFee(size) {
      if (this.securityFeeEnabled) {
        return round((this.facilityData.securityFee.fee / 100) * size);
      }
      return 0;
    },
    computeSecurityFeeTax(fee) {
      if (this.securityFeeTaxEnabled) {
        const facilitySecurityFeeTax = this.facilityData.feeTypesTaxPricing.find(feeTypeTax => feeTypeTax.type === 'Security');
        const securityFeeTax = (facilitySecurityFeeTax.rate / 100) * fee;
        return round(securityFeeTax);
      }
      return 0;
    },
    prepareLineItems(dueDate) {
      const lineItems = [];
      let accountBalance = Number(0);

      // add prorated price.
      this.selectedUnitsData.forEach((unit) => {
        const unitProratedPrice = unit.editable ? Number(this.newPrice(unit, true)) : Number(this.computePrice(unit, true));
        const totalPriceOfTheUnit = unit.editable ? unit.editPrice : Number(
          this.computePrice(unit, false, true),
        );
        const unitRentalTax = Number(this.computeTax(unitProratedPrice));
        const securityDeposit = unit.depositEditable ? unit.editDeposit : totalPriceOfTheUnit;
        accountBalance += unitProratedPrice;
        let uniqId = nanoid();
        lineItems.push({
          createdAt: new Date(),
          period: dueDate,
          description: `Prorated Rent from ${this.$options.filters.formatDate(this.form.moveIn)} of ${this.getTotalRemainingDays()} days for unit: ${
            unit.name
          }`,
          amount: unitProratedPrice,
          accountBalance,
          dueDate,
          type: 'CREDIT',
          details: 'RENT',
          chargeType: 'RENT',
          unit: unit._id,
          uniqId,
        });

        if (unitRentalTax > 0 && this.customerData && this.customerData.taxExempted === false) {
          accountBalance += unitRentalTax;
          let description = `Rental Tax for unit ${unit.name}`;
          if (this.facilityData && this.facilityData.tax && this.facilityData.tax.rentTaxLabel) {
            description = `${this.facilityData.tax.rentTaxLabel} @ ${this.facilityData.tax.rentTaxRate}% for unit ${unit.name} rent.`;
          }

          lineItems.push({
            createdAt: new Date(),
            period: dueDate,
            description,
            amount: round(unitRentalTax),
            accountBalance: round(accountBalance),
            dueDate,
            type: 'CREDIT',
            details: 'TAX',
            chargeType: 'TAX',
            sourceType: 'RENT',
            unit: unit._id,
            source: uniqId,
          });
        }

        if (this.securityFeeEnabled) {
          uniqId = nanoid();
          const securityFee = this.computeSecurityFee(unit.computedSize);
          const proratedSecurityFee = this.computeProratedSecurityFee(securityFee);
          const securityFeeLineItem = {
            createdAt: new Date(),
            period: dueDate,
            description: ` Prorated ${this.facilitySecurityFeeLabel} from ${this.$options.filters.formatDate(this.form.moveIn)} of ${this.getTotalRemainingDays()} days for Unit ${unit.name}`,
            amount: proratedSecurityFee,
            accountBalance,
            dueDate,
            details: 'FEES',
            chargeType: 'FEES',
            feeType: 'Security',
            unit: unit._id,
            type: 'CREDIT',
            uniqId,
          };
          lineItems.push(securityFeeLineItem);

          if (this.securityFeeTaxEnabled && (!this.customerData || (this.customerData && this.customerData.taxExempted === false))) {
            this.computeSecurityFeeTax(proratedSecurityFee);
            const securityFeeTax = this.computeSecurityFeeTax(proratedSecurityFee);
            accountBalance += securityFeeTax;

            const securityFeeTaxLineItem = getLeaseTaxLineItem(securityFeeLineItem, this.facilityData);
            if (securityFeeTaxLineItem.amount) {
              lineItems.push(securityFeeTaxLineItem);
            }
          }
        }

        accountBalance += securityDeposit;
        lineItems.push({
          createdAt: new Date(),
          period: dueDate,
          description: `Security Deposit for unit ${unit.name}`,
          amount: round(securityDeposit),
          accountBalance: round(accountBalance),
          dueDate,
          type: 'CREDIT',
          details: 'DEPOSIT',
          chargeType: 'DEPOSIT',
          unit: unit._id,
          source: uniqId,
        });
      });
      return lineItems;
    },
    computeProratedSecurityFee(securityFee) {
      const totalProrateDays = this.getTotalRemainingDays();
      const totalDaysOfMonth = this.getTotalDaysOfMoveInMonth();

      if (totalProrateDays >= totalDaysOfMonth) {
        return securityFee;
      }
      const oneDayPrice = securityFee / totalDaysOfMonth;
      return totalProrateDays > 0
        ? round(oneDayPrice * totalProrateDays)
        : 0;
    },
    prepareDebitLineItems(transactions, dueDate) {
      const debitLineItems = [];
      let totalDueAmount = this.dueAmount;
      // const totalDeposit = this.deposit;
      // const amountPaid = transactions.map(transaction => transaction.amountPaid)
      //   .reduce((amtP, amtC) => amtP + amtC, 0);

      // const depositAmount = lineItems.filter(item => item.chargeType === 'DEPOSIT').reduce((amtp, amtc) => amtp + amtc, 0);
      // const rentAmount = lineItems.filter(item => item.chargeType === 'RENT').reduce((amtp, amtc) => amtp + amtc, 0);
      // const feeAmount = lineItems.filter(item => item.chargeType === 'FEE').reduce((amtp, amtc) => amtp + amtc, 0);
      // const taxAmount = lineItems.filter(item => item.chargeType === 'TAX').reduce((amtp, amtc) => amtp + amtc, 0);

      // const PriorityDebitLineItemsBasedOnType = ['DEBIT', 'RENT', 'FEE', 'TAX'];

      // const depositFlag = false;
      // const rentFlag = false;
      // const feeFlag = false;
      // const taxFlag = false;
      transactions.forEach((transaction) => {
        totalDueAmount -= transaction.amount;
        // #1 DEPOSITS
        if (transaction.success) {
          debitLineItems.push({
            paidAt: transaction.createdAt,
            transaction: transaction.id,
            description: `Payment done via transaction ${transaction.id}`,
            transactionType: transaction.type,
            createdAt: new Date(),
            period: dueDate,
            amount: -(round(transaction.amountPaid)),
            accountBalance: round(totalDueAmount),
            type: 'DEBIT',
          });
        }
      });
      return debitLineItems;
    },
    addTag(value) {
      const values = this.tags.map(item => item.value);
      if (!values.includes(value)) {
        this.tags.push({ value });
      }
      this.tagInput = '';
    },
    addUnit() {
      const unit = {
        ...this.form,
        tags: [...this.tags],
        images: [...this.images],
      };
      this.$emit('unit-added', unit);
    },
    addImageToUnit(url) {
      this.images.push({ url, createdBy: this.$keycloak.tokenParsed.email });
    },
    removeImage(url) {
      const updatedImages = this.images.map(document => document.url !== url);
      this.images = updatedImages;
    },
    getTotalRemainingDays() {
      const moveIn = this.form.moveIn;
      const moveOut = this.form.moveOut;
      const date = moveIn.getDate();
      const currentYear = moveIn.getFullYear();
      const currentMonth = moveIn.getMonth();
      const totalDaysInCurrentMonth = new Date(
        currentYear,
        currentMonth + 1,
        0,
      ).getDate();

      if (moveOut && currentMonth === moveOut.getMonth() && currentYear === moveOut.getFullYear()) {
        const moveOutDay = moveOut.getDate();
        return moveOutDay - date > 0 ? (moveOutDay - date) + 1 : 1;
      }

      return totalDaysInCurrentMonth - date > 0
        ? (totalDaysInCurrentMonth - date) + 1
        : 1;
    },
    getTotalDaysOfMoveInMonth() {
      const moveIn = this.form.moveIn;
      const currentYear = moveIn.getFullYear();
      const currentMonth = moveIn.getMonth();
      return new Date(currentYear, currentMonth + 1, 0).getDate();
    },
    getNextBillingDate() {
      const moveIn = this.form.moveIn;
      const moveOut = this.form.moveOut;
      if (moveOut) {
        const moveInYear = moveIn.getFullYear();
        const moveInMonth = moveIn.getMonth();
        const moveOutYear = moveOut.getFullYear();
        const moveOutMonth = moveOut.getMonth();

        if (moveInYear === moveOutYear && moveInMonth === moveOutMonth) {
          return null;
        }
      }
      const lastDayOfMonth = this.getTotalDaysOfMoveInMonth();
      const companyPolicyNextBillingDate = new Date(
        moveIn.getFullYear(),
        moveIn.getMonth(),
        lastDayOfMonth - 7,
      );
      const lastDayDateOfMoveIn = new Date(
        moveIn.getFullYear(),
        moveIn.getMonth(),
        lastDayOfMonth,
      );

      if (
        companyPolicyNextBillingDate < moveIn ||
        companyPolicyNextBillingDate < new Date()
      ) {
        if (lastDayDateOfMoveIn <= moveIn) {
          return new Date(moveIn.getFullYear(), moveIn.getMonth() + 1, 1);
        }
        return new Date(
          moveIn.getFullYear(),
          moveIn.getMonth(),
          lastDayOfMonth,
        );
      }
      return companyPolicyNextBillingDate;
    },
    computeTax(price) {
      if (!this.facilityData.rentTaxFlag) {
        return 0;
      }
      const taxRate = this.facilityData.tax.rentTaxRate;

      const taxValue = price * (taxRate / 100);
      return taxValue;
    },
    newPrice(unit, prorated = false, monthly = false) {
      return this.computeNewPrice(unit, prorated, monthly);
    },
    computeNewPrice(unit, prorated, monthly) {
      const totalProrateDays = this.getTotalRemainingDays();
      this.proratedDays = this.getTotalRemainingDays();
      const totalDaysOfMonth = this.getTotalDaysOfMoveInMonth();

      if (prorated) {
        if (this.proratedDays >= totalDaysOfMonth) {
          return unit.editPrice;
        }
        const oneDayPrice = unit.editPrice / totalDaysOfMonth;
        return totalProrateDays > 0
          ? round(oneDayPrice * totalProrateDays)
          : 0;
      }
      return round(unit.editPrice);
    },
    computePrice(unit, prorated, monthly) {
      const price = computeUnitPricing(unit, this.facilityData);
      const totalMonths = getTotalMonths();
      this.proratedDays = this.getTotalRemainingDays();
      const totalProrateDays = this.getTotalRemainingDays();
      const totalDaysOfMonth = this.getTotalDaysOfMoveInMonth();
      if (prorated) {
        if (this.proratedDays >= totalDaysOfMonth) {
          return price;
        }
        const oneDayPrice = price / totalDaysOfMonth;
        return totalProrateDays > 0
          ? round(oneDayPrice * totalProrateDays)
          : 0;
      }
      if (monthly) {
        return price;
      }
      return price * totalMonths;
    },
    async prepareSelectedUnit() {
      this.preparingSelectedUnitsData = true;
      const rentals = await this.getConflicts();
      if (rentals.length) {
        return;
      }

      // Clear the array before adding new units
      this.selectedUnitsData = [];

      this.selectedUnits.forEach((item) => {
        const [foundUnit] = this.units.filter((unit) => {
          if (unit._id === item) {
            return unit;
          }
        });
        const unitCopy = { ...foundUnit };
        unitCopy.editable = false;
        unitCopy.editPrice = 0;
        unitCopy.depositEditable = false;
        unitCopy.editDeposit = 0;
        unitCopy.validate = false;
        this.selectedUnitsData.push(unitCopy);
      });
      this.active += 1;

      this.preparingSelectedUnitsData = false;
    },
    next() {
      if (this.isBanned) {
        this.clearFields();
        this.$emit('close');
        this.$message.warning({
          title: 'Warning',
          message: 'Customer is banned',
        });
      }
      switch (this.active) {
        case 0:
          return this.$refs.details.validate((valid) => {
            if (valid) {
              this.active += 1;
            }
          });
        case 1:
          this.active += 1;
          break;
        case 2:
          this.active += 1;
          break;
        case 3:
          this.active += 1;
          break;
        case 4:
          this.active += 1;
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style scoped>
.tags {
  margin-top: 8px;
}

.tag {
  margin-right: 8px;
}

</style>



// WEBPACK FOOTER //
// src/components/CustomerRental.vue